import Vue from "vue";
import App from "./App.vue";
import router from "./router/";
import store from "./store/";
import mixins from "./mixins/";

import "./utils/index";
import "./assets/scss/common/common.scss";
import "./assets/scss/variables.scss";
// plugin
import "./plugins/element";

import ElementUI from "element-ui";
import locale from "element-ui/lib/locale/lang/en";
// customer SCSS
import "./assets/scss/base.scss";
import "element-ui/lib/theme-chalk/base.css";
import CollapseTransition from "element-ui/lib/transitions/collapse-transition";
import * as Echarts from "echarts";
import {
  Tree
} from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';

import dayjs from "dayjs";
import timezone from "moment-timezone";
import VueI18n from "vue-i18n";
import VueAMap from "vue-amap";
import 'vue-event-calendar/dist/style.css' // 1.1.10之后的版本，css被放在了单独的文件中，方便替换
import vueEventCalendar from 'vue-event-calendar'
Vue.use(vueEventCalendar, { locale: 'en' }) // 可以设置语言，支持中文和英文
Vue.use(VueAMap);
Vue.use(VueI18n);
Vue.component(Tree.name, Tree)
let language = sessionStorage.getItem("power-language");
if (language) {
  store.commit("updateLanguage", language);
}
const { utcToZonedTime } = require("date-fns-tz");
const i18n = new VueI18n({
  locale: language || "en", // 语言标识
  // this.$i18n.locale // 通过切换locale的值来实现语言切换
  messages: {
    "zh": require("../src/assets/lang/zh"), // 中文簡體语言包
    "tc": require("../src/assets/lang/tc"), // 中文繁體語言包
    "en": require("../src/assets/lang/en") // 英文语言包
  }
});
VueAMap.initAMapApiLoader({
  // 高德的key
  key: "c21e5d7b871b848980e862b7fb296604",
  // 插件集合
  plugin: [
    "AMap.Autocomplete",
    "AMap.PlaceSearch",
    "AMap.Scale",
    "AMap.OverView",
    "AMap.ToolBar",
    "AMap.MapType",
    "AMap.PolyEditor",
    "AMap.CircleEditor"
  ],
  // 高德 sdk 版本，默认为 1.4.4
  v: "1.4.15"
});
Vue.use(ElementUI, { locale });
Vue.prototype.$echarts = Echarts;
Vue.prototype.$dayjs = dayjs;
Vue.prototype.$timezone = timezone;
Vue.prototype.$utcToZonedTime = utcToZonedTime;

Vue.component(CollapseTransition.name, CollapseTransition);

Vue.config.productionTip = false;
Vue.mixin(mixins);
let token = localStorage.getItem("power-token");
let userInfo = JSON.parse(localStorage.getItem("power-userInfo"));
if (token) {
  store.commit("updateToken", token);
  store.commit("updateUserInfo", userInfo);
}
let vue = new Vue({
  router,
  i18n,
  store,
  render: h => h(App)
}).$mount("#app");
window.vue = vue;
export default vue;
